function gsInitReveal() {
  var items = document.querySelectorAll('.gs-reveal:not(.gs-visible)');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('gs-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gs-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  items.forEach(function (el) { observer.observe(el); });

  /* Salvaguarda: si la pestaña está en segundo plano o el navegador no
     dispara el observer a tiempo, el contenido no debe quedar invisible. */
  setTimeout(function () {
    document.querySelectorAll('.gs-reveal:not(.gs-visible)').forEach(function (el) {
      el.classList.add('gs-visible');
    });
  }, 2500);
}

function gsInitGalerias() {
  document.querySelectorAll('[data-gs-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-gs-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-gs-galeria-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var url = mini.getAttribute('data-full');
        if (!url) return;
        principal.querySelector('img').src = url;
        minis.forEach(function (m) { m.classList.remove('is-active'); });
        mini.classList.add('is-active');
      });
    });
  });
}

function gsInitCompra() {
  document.querySelectorAll('[data-gs-compra]').forEach(function (root) {
    var cantidadInput = root.querySelector('[data-gs-cantidad-input]');
    root.querySelectorAll('[data-gs-cantidad-menos]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!cantidadInput) return;
        cantidadInput.value = Math.max(1, (parseInt(cantidadInput.value, 10) || 1) - 1);
      });
    });
    root.querySelectorAll('[data-gs-cantidad-mas]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!cantidadInput) return;
        cantidadInput.value = (parseInt(cantidadInput.value, 10) || 1) + 1;
      });
    });

    var variantsJson = root.querySelector('[data-gs-variantes]');
    if (!variantsJson) return;
    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }
    var idInput = root.querySelector('[data-gs-variant-id]');
    var precioEl = root.querySelector('[data-gs-precio]');
    var precioTachadoEl = root.querySelector('[data-gs-precio-tachado]');
    var btnComprar = root.querySelector('[data-gs-btn-comprar]');
    var pillGroups = root.querySelectorAll('[data-gs-opcion]');

    function opcionesSeleccionadas() {
      var seleccion = [];
      pillGroups.forEach(function (grupo) {
        var activo = grupo.querySelector('.is-active');
        seleccion.push(activo ? activo.getAttribute('data-value') : null);
      });
      return seleccion;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var variante = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.price_formatted;
      if (precioTachadoEl) {
        if (variante.compare_show) {
          precioTachadoEl.textContent = variante.compare_price_formatted;
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (btnComprar) {
        btnComprar.disabled = !variante.available;
        btnComprar.textContent = variante.available
          ? btnComprar.getAttribute('data-label-disponible')
          : btnComprar.getAttribute('data-label-agotado');
      }
      pillGroups.forEach(function (grupo) {
        grupo.querySelectorAll('[data-gs-pill]').forEach(function (pill) {
          var testSeleccion = opcionesSeleccionadas();
          var idx = Array.prototype.indexOf.call(pillGroups, grupo);
          testSeleccion[idx] = pill.getAttribute('data-value');
          var existe = variants.some(function (v) {
            return v.options.every(function (opt, i) { return opt === testSeleccion[i]; });
          });
          pill.disabled = !existe;
        });
      });
    }

    pillGroups.forEach(function (grupo) {
      grupo.querySelectorAll('[data-gs-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          grupo.querySelectorAll('[data-gs-pill]').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  gsInitReveal();
  gsInitGalerias();
  gsInitCompra();
});
